var TopAnnouse = document.querySelector('.close_announcement');
var bodyClass = document.querySelector('body');

if (TopAnnouse) {
  TopAnnouse.addEventListener('click', function() {
    bodyClass.classList.add('annousementHide');
  });
}

$(document).ready(function () {
  const slides = document.querySelectorAll('.slideshow__slide');
  if (slides.length) {
    const prevButton = document.querySelector('.slider-button--prev');
    const nextButton = document.querySelector('.slider-button--next');
    slides.forEach((slide) => {
      let isMouseDown = false;
      let startX = 0;

      slide.addEventListener('mousedown', (event) => {
        isMouseDown = true;
        startX = event.clientX;
      });

      slide.addEventListener('mousemove', (event) => {
        if (!isMouseDown) return;

        const currentX = event.clientX;
        const dragDistance = Math.abs(currentX - startX);

        if (dragDistance >= 50) { // Only fire the event if drag distance is 50px or more
          const direction = currentX < startX ? 'left' : 'right';
          if (direction === 'left' && !nextButton.classList.contains('disable')) {
            nextButton.click();
          } else if (direction === 'right' && !prevButton.classList.contains('disable')) {
            prevButton.click();
          }
          isMouseDown = false; // Reset mouse state after firing the event
        }
      });

      slide.addEventListener('mouseup', () => {
        isMouseDown = false;
      });

      slide.addEventListener('mouseleave', () => {
        isMouseDown = false;
      });
    });
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const currentCounter = document.querySelector(".slider-counter--current");
  const totalCounter = document.querySelector(".slider-counter--total");
  const prevButton = document.querySelector(".slider-button--prev");
  const nextButton = document.querySelector(".slider-button--next");

  if (!currentCounter || !totalCounter || !prevButton || !nextButton) {
    return;
  }

  function updateButtonStates() {
    const currentValue = parseInt(currentCounter.textContent, 10) || 0;
    const totalValue = parseInt(totalCounter.textContent, 10) || 0;

    if (currentValue <= 1) {
      prevButton.classList.add("disable");
      prevButton.setAttribute("disabled", "true");
    } else {
      prevButton.classList.remove("disable");
      prevButton.removeAttribute("disabled");
    }
    
    if (currentValue >= totalValue) {
      nextButton.classList.add("disable");
      nextButton.setAttribute("disabled", "true");
    } else {
      nextButton.classList.remove("disable");
      nextButton.removeAttribute("disabled");
    }
  }

  updateButtonStates();

  nextButton.addEventListener("click", function () {
    let currentValue = parseInt(currentCounter.textContent, 10) || 0;
    const totalValue = parseInt(totalCounter.textContent, 10) || 0;

    if (currentValue < totalValue) {
      currentCounter.textContent = currentValue + 1;
      updateButtonStates();
    }
  });

  prevButton.addEventListener("click", function () {
    let currentValue = parseInt(currentCounter.textContent, 10) || 0;

    if (currentValue > 1) {
      currentCounter.textContent = currentValue - 1;
      updateButtonStates();
    }
  });
});

